export const comments_3324447 = {"data":{"data":[],"links":{}}}